import axios from 'axios'
export default {
	install(Vue, options) {
		Vue.prototype.SYS = {};//'http://192.168.3.7:8899';//'http://localhost:5000';//"http://localhost:8080";//
		Vue.prototype.__defineGetter__("SYS", function () {
			return configdata;//'http://192.168.3.7:8899';//'http://localhost:5000';//"http://nat.yy528.com:50071";//
		})
		//Vue.prototype.HostUrl = "";//'http://localhost:5000';//"http://localhost:8080";//
		Vue.prototype.__defineGetter__("HostUrl", function () {
			return "";//"http://localhost:8080";//'http://localhost:5000';//
		})
		Vue.prototype.nowdate = function()
		{
			return this.FormatDate(new Date())
		}
		Vue.prototype.chklevel = function(path) {
			return this.$UL.chklevel(path)
		}
		Vue.prototype.formathtml=function(content) { //格式化文本为html代码
			if (!content)
				return "";
			var res = "<p>" + content.replace(/\r\n/g, '</p><p>') + "</p>";
			res = res.replace(/\n/g, "<br>");
			res = res.replace(/\s/g, "&nbsp;");
			return res
		}
		Vue.prototype.checkStrong = function(sValue) {
			var modes = 0;
			if (sValue.length < 1) 
				return modes;
			if(sValue.length<6)
				return 1;
			if (/\d/.test(sValue)) modes++;
			if (/[a-z]/.test(sValue)) modes++;
			if (/[A-Z]/.test(sValue)) modes++;
			if (/\W/.test(sValue)) modes++;
			switch (modes) {
				case 1:
					return 1;
					break;
				case 2:
					return 2;
					break;
				case 3:
				case 4:
					return sValue.length < 4 ? 3 : 4;
				break;
			}
			return modes;
		}
		Vue.prototype.apihost = "/api/";
		Vue.prototype.token = "Bearer ";
		Vue.prototype.GUID = function(){
			function S4() {
				return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
			}
			return (S4() + S4()  + S4() + S4() + S4() + S4() + S4() + S4());
		}
		Vue.prototype.getpercentage=function(f1,f2){
			return parseInt((f1/f2*100).toFixed(0))
		}
		Vue.prototype.DownExcelFile = function(method,pars, callback, errback){
			let errcn=""
			var authtoken = "Bearer " + this.CU.token
			let that = this
			axios.defaults.baseURL = '/api'
			axios({
				url: method,
				method: "get",
				headers: { "Authorization": authtoken},
				params: pars
			}).then(function (res) {
				switch(res.data.error_code){
					case 0:
						callback(res)
						break;
					case 200:
						callback(res)
						break;
					case 401:
						let curcu = that.CU;
						curcu.pwd = ""
						curcu.token = ""
						that.setItem("currentuser", curcu)
						that.$router.replace("/");
						break;
					default:
						errcn = res.data.message.replace('Duplicate entry','数据重复：')
						errback(errcn)
				}
			}).catch(function (err) {
				if(err.toString().indexOf('401')>=0){
					let curcu = that.CU;
					curcu.pwd = ""
					curcu.token = ""
					that.setItem("currentuser", curcu)
					that.$router.replace("/");
				}else{
					errcn = err.toString().replace('Duplicate entry','数据重复：')
					errback(errcn)
				}	
			});
		}
		Vue.prototype.GetData = function (method, pars, callback, errback) {
			let errcn=""
			var authtoken = "Bearer " + this.CU.token
			let that = this
			axios.defaults.baseURL = '/api'
			const loading = this.$loading({
				lock: true,
				text: '加载中...',
				spinner: 'el-icon-loading',
				background: 'transparent'//'rgba(0, 0, 0, 0.7)'
			})
			axios({
				url: method,
				method: "get",
				headers: { "Authorization": authtoken },
				params: pars
			}).then(function (res) {
				loading.close();
				switch(res.data.error_code){
					case 0:
						callback(res)
						break;
					// case 200:
					// 	callback(res)
					// 	break;
					case 401:
						let curcu = that.CU;
						curcu.pwd = ""
						curcu.token = ""
						that.setItem("currentuser", curcu)
						that.$router.replace("/");
						break;
					default:
						errcn = res.data.message.replace('Duplicate entry','数据重复：')
						if(errback)
							errback(errcn)
				}
			}).catch(function (err) {
				loading.close();
				if(err.toString().indexOf('401')>=0){
					let curcu = that.CU;
					curcu.pwd = ""
					curcu.token = ""
					that.setItem("currentuser", curcu)
					that.$router.replace("/");
				}else{
					errcn = err.toString().replace('Duplicate entry','数据重复：')
					if(errback)
						errback(errcn)
				}	
			});
		}
		//获取字典字段项tn:表名，fn:字段名，flag:是否显示全部，
		Vue.prototype.GETENUM = function(tn,fn,flag,callback){
			let that = this
			that.GetData('Common/GETENUM',{tableName:tn,fieldName:fn,flag:flag},function(res){
			  callback(res.data.data)
			},function(err){
			  that.$alert(err, {title: "错误",type: 'error'});
			})
		}
		//获取字典数据
		Vue.prototype.GetDict = function(dicttype,callback){
			let that = this
			let wherestring = [{field: 'dict_type',sym: '=',val: dicttype,oper: 'and'},]
			let pars = {objname: "sys_dicts",wheres: wherestring,PageSize: 9999,CurrentPage: 1,orderbys:[{field:'dict_oid',asc:'asc'}]}
			that.PostData("Common/GETLIST", pars,function (res) {
			  callback(res.data)
			},function (err) {
			  that.$alert(err, {title: "错误"});
			}
		  );
	  	}
		Vue.prototype.GetYears=function(callback){
			let that = this
			that.GetData("Years", {},function (res) {
				callback(res.data)
			},function (err) {
			  that.$alert(err, {title: "错误"});
			}
		  );
		}
		Vue.prototype.PostDataPDF = function (methodname, pars, callback, errback) {
			let errcn=""
			const that = this
			var authtoken = "Bearer " + that.CU.token
			const loading = this.$loading({
				lock: true,
				text: '加载中...',
				spinner: 'el-icon-loading',
				background: 'transparent'//'rgba(0, 0, 0, 0.7)'
			})
			axios.defaults.baseURL = "/api"
			axios({
				url: methodname,
				method: "post",
				headers: { "Authorization": authtoken, "Content-Type": "application/json" },//"multipart/form-data"},//
				responseType:'blob',
				data: pars
			}).then(function (res) {
				loading.close()
				callback(res)
			}).catch(function (err) {
				console.log(err)
				loading.close()
				if(err.toString().indexOf('401')>=0){
					let curcu = that.CU;
					curcu.pwd = ""
					curcu.token = ""
					that.setItem("currentuser", curcu)
					that.$router.replace("/");
				}else{
					errcn = err.toString().replace('Duplicate entry','数据重复：')
					errback(errcn)
				}	
			});
		}
		Vue.prototype.PostData = function (methodname, pars, callback, errback) {
			let errcn=""
			const that = this
			var authtoken = "Bearer " + that.CU.token
			const loading = this.$loading({
				lock: true,
				text: '加载中...',
				spinner: 'el-icon-loading',
				background: 'transparent'//'rgba(0, 0, 0, 0.7)'
			})
			axios.defaults.baseURL = "/api"
			axios({
				url: methodname,
				method: "post",
				headers: { "Authorization": authtoken, "Content-Type": "application/json" },//"multipart/form-data"},//
				data: pars
			}).then(function (res) {
				loading.close()
				switch(res.data.error_code){
					case 0:
						callback(res)
						break;
					// case 200:
					// 	callback(res)
					// 	break;
					case 401:
						let curcu = that.CU;
						curcu.pwd = ""
						curcu.token = ""
						that.setItem("currentuser", curcu)
						that.$router.replace("/");
						break;
					default:
						errcn = res.data.message.replace('Duplicate entry','数据重复：')
						errback(errcn)
				}
			}).catch(function (err) {
				console.log(err)
				loading.close()
				if(err.toString().indexOf('401')>=0){
					let curcu = that.CU;
					curcu.pwd = ""
					curcu.token = ""
					that.setItem("currentuser", curcu)
					that.$router.replace("/");
				}else{
					errcn = err.toString().replace('Duplicate entry','数据重复：')
					errback(errcn)
				}	
			});
		}
		//上传大型文件
		Vue.prototype.PostBigFile = function(methodname, pars, file,chunk,guid,callback){
			let that = this
			let chunkSize =5120576;//5Mb
			let fileSize = file.size;
			let maxChunk = Math.ceil(fileSize / chunkSize);//片数
			let currentPercent = parseInt((chunk / maxChunk) * 100);//进度
			let filechunk = file.slice(chunk * chunkSize, (chunk+1) * chunkSize)
			let filepar = Object.assign({},pars)
			filepar.guid = guid
			filepar.maxChunk = maxChunk
			filepar.chunk = chunk
			filepar.name = file.name
			const loading = this.$loading({
				lock: true,
				text: '加载中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			})
			that.PostFile(methodname,filepar,filechunk,function(res){
				loading.close()
				if (res.data.error_code == 0) {
					callback(res)
					if(res.data.completed){
						console.log('上传成功！'+res)
					}else{
						that.PostBigFile(methodname,pars,file,++chunk,guid,function(res){
							callback(res)
						})
					}
				}
			},function(err){
				loading.close()
				console.log(err)
			},function(progress){

			})
		}
		Vue.prototype.PostFile = function (methodname, pars, file, callback, errback,progressback) {
			var authtoken = "Bearer " + this.CU.token
			axios.defaults.baseURL = "/api"
			let formdata = new FormData()
			formdata.append("file", file);
			for (let p in pars) {
				formdata.append(p, pars[p])
			}

			axios({
				url: methodname,
				method: "post",
				headers: { "Authorization": authtoken, "Content-Type": "multipart/form-data" },//"application/json"},//
				data: formdata,
				onDownloadProgress (progress) {
					let ress = Math.round(progress.loaded / progress.total * 100)
					progressback(ress)
				}
			}).then(function (res) {
				switch(res.data.error_code){
					case 0:
						callback(res)
						break;
					// case 200:
					// 	callback(res)
					// 	break; 
					case 401:
						let curcu = that.CU;
						curcu.pwd = ""
						curcu.token = ""
						that.setItem("currentuser", curcu)
						that.$router.replace("/");
						break;
					default:
						errback(res.data.message)
				}
			}).catch(function (err) {
				if(err.toString().indexOf('401')>=0){
					let curcu = that.CU;
					curcu.pwd = ""
					curcu.token = ""
					that.setItem("currentuser", curcu)
					that.$router.replace("/");
				}else{
					let errcn = err.toString().replace('Duplicate entry','数据重复：')
					errback(errcn)
				}
			});
		}

		Vue.prototype.FormatDate = function (val) {
			if (val) {
				let date = new Date(val)
				let Y = date.getFullYear();
				let M = date.getMonth() + 1;
				let D = date.getDate();

				if (M < 10) {
					M = '0' + M;
				}
				if (D < 10) {
					D = '0' + D;
				}
				return Y + '-' + M + '-' + D;
			} else {
				return '';
			}
		}
		Vue.prototype.FormatDateTime = function (val) {
			if (val) {
				let date = new Date(val)
				let Y = date.getFullYear();
				let M = date.getMonth() + 1;
				let D = date.getDate();
				let H = date.getHours();
				let m = date.getMinutes();
				let s = date.getSeconds();
				if (M < 10) {
					M = '0' + M;
				}
				if (D < 10) {
					D = '0' + D;
				}
				if(H<10)
					H = "0"+H
				if(m<10)
					m = '0'+m
				if(s<10)
				    s = '0'+s
				return Y + '-' + M + '-' + D+ " "+H+":"+m+":"+s;
			} else {
				return '';
			}
		}
		Vue.prototype.TimeDiff = function(bdatestring,edatestring) {
			let bdate = null
			let edate = null
			if(bdatestring)
				bdate = new Date(bdatestring).getTime()
			else
				bdate =  new Date().getTime()
			if(edatestring)
				edate = new Date(edatestring).getTime()
			else
				edate =  new Date().getTime()
			let td = bdate-edate
			let days=Math.floor(td/(24*3600*1000))  
			let hours=Math.floor(td%(24*3600*1000)/(3600*1000))
			return {dd:days,hh:hours,td:td}
			//return "还有"+days+"天 "+hours+"小时";
		}
		Vue.prototype.getyears = function(callback){
			let that = this
			that.GetData('years',null,function(res){
				callback(res.data.data)
			},function(err){
				console.log(err)
			})
		},
		Vue.prototype.RefreshToken = function(callback){
			const that = this;
			that.GetData('RefreshToken',{},function(res){
				switch(res.data.error_code){
					case 0:
						that.setItem("currentuser", {token:res.data.token,cu:res.data.currentuser})
						that.setItem("menus",res.data.menus)
						callback(res)
						break;
					case 200:
						that.setItem("currentuser", {token:res.data.token,cu:res.data.currentuser})
						that.setItem("menus",res.data.menus)
						callback(res)
						break;
					default:
						let curcu = that.CU;
						curcu.pwd = ""
						curcu.token = ""
						that.setItem("currentuser",curcu);
						that.$router.replace('/');
						break;
				}
			},function(err){
				console.log(err)
				let curcu = that.CU;
				curcu.pwd = ""
				curcu.token = ""
				that.setItem("currentuser",curcu);
				that.$router.replace('/')
			})
		}
		// Vue.prototype.RELOGIN = function (callback) {
		// 	const that = this
		// 	that.LOGIN(that.CU.cu.uclass,that.CU.cu.sid,that.CU.cu.uid,that.CU.pwd,callback,function(){
		// 		let curcu = that.CU;
		// 		curcu.pwd = ""
      	// 		curcu.token = ""
		// 		that.setItem("currentuser",curcu);
		// 		that.$router.replace('/')
		// 	})
		// }
		Vue.prototype.LOGIN = function (userName, pwd,vcode, callback, errback) {
			const that = this;
			that.GetData(
				"AuthSYS",
				{
					userid: userName,
					pwd: pwd,
					vcode:vcode
				},
				function (res) {
					switch(res.data.error_code){
						case 0:
							that.setItem("currentuser", {token:res.data.token,cu:res.data.currentuser})
							that.setItem("menus",res.data.menus)
							callback(res)
							break;
						// case 200:
						// 	that.setItem("currentuser", {token:res.data.token,cu:res.data.currentuser})
						// 	callback(res)
						// 	break;
						default:
							errback(res.data.message)
					}
				},
				function (err) {
					errback(err)
				}
			);
		}
		Vue.prototype.inputmethod = function() {
			this.$forceUpdate()
		}
		Vue.prototype.CU = {}
		Vue.prototype.__defineGetter__("CU", function () {
			let currentuser = this.getItem("currentuser")
			if (!currentuser)
				currentuser = { token: '', pwd: '', exp: '', cu: { uid:'',uname:'',uclass:'管理员',srid:''} }
			return currentuser
		})
		Vue.prototype.getItem = function (lsitem) {
			return JSON.parse(window.localStorage.getItem(lsitem));
		}
		Vue.prototype.setItem = function (lsname, lsvalue) {
			window.localStorage.setItem(lsname, JSON.stringify(lsvalue))
		}
		Vue.prototype.GetSFT = function(){//query:{SFT:''}
			let sftstring = decodeURIComponent(this.$route.params.SFT)
			let sft = JSON.parse(sftstring)
			return sft;
		}
		Vue.prototype.SetSFT = function(sft){//query:{SFT:''}
			let sftstring = encodeURIComponent(JSON.stringify(sft))
			return sftstring
		}
		///查找结构树的某个值
		//parentnode:父对象信息
		//json数组
		//nodekey:字段名
		//nodevalue:字段值
		//返回：pnode父节点，node:查找到的节点，nodeindex属于父节点下的第几个节点
		Vue.prototype.getnode = function(parentnode, json,nodekey, nodevalue) {
			//查找结构树的某个值
			for (var i = 0; i < json.length; i++) {
					if (json[i][nodekey] == nodevalue){
						return {
							pnode: parentnode,
							node: json[i],
							nodeindex: i
						};
					}							
					else {
							if (json[i].children) {
									let node = this.getnode(json[i], json[i].children, nodekey,nodevalue);
									if (node) return node;
							}
							continue;
					}
			}
			return null;
		}
	}
}